import { useState, useEffect } from 'react';
import { useGeoMarkupStore } from '@/store';

interface UseTaskHasNotesResult {
  hasNotes: boolean;
  isLoading: boolean;
}

/**
 * Checks whether a task has any linked notes.
 * Returns { hasNotes, isLoading } — used to conditionally show/hide the Notes tab.
 */
export function useTaskHasNotes(
  taskId: string | undefined
): UseTaskHasNotesResult {
  const fetchNotesByTaskId = useGeoMarkupStore(
    (state) => state.notes.fetchNotesByTaskId
  );
  const [hasNotes, setHasNotes] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!taskId) {
      setHasNotes(false);
      setIsLoading(false);
      return;
    }

    let cancelled = false;
    setIsLoading(true);

    const check = async () => {
      const notes = await fetchNotesByTaskId(taskId);
      if (!cancelled) {
        setHasNotes(notes.length > 0);
        setIsLoading(false);
      }
    };

    check();

    return () => {
      cancelled = true;
    };
  }, [taskId, fetchNotesByTaskId]);

  return { hasNotes, isLoading };
}
